"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var commons_1 = require("../../core/commons");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Reduced baseline entity. It contains subset of baseline attributes.
 * @author VRu
 */


var BaselineInfo =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(BaselineInfo, _DomainObject_1$Domai);

  /**
   * @param productId the internal id of product
   * @param siteId the internal site id
   * @param date
   * @param amount
   */
  function BaselineInfo(productId, siteId, date, amount) {
    var _this;

    _classCallCheck(this, BaselineInfo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaselineInfo).call(this));
    _this.productId = productId;
    _this.siteId = siteId;
    _this.date = date;
    _this.amount = amount;
    return _this;
  } // compatibility with converters and repositories


  _createClass(BaselineInfo, [{
    key: "id",
    get: function get() {
      return commons_1.UNIMPLEMENTED('Use Baseline to get id.');
    }
  }]);

  return BaselineInfo;
}(DomainObject_1.DomainObject);

exports.BaselineInfo = BaselineInfo;
BaselineInfo.projection = {
  _id: 0,
  productId: 1,
  siteId: 1,
  date: 1,
  amount: 1
};

BaselineInfo.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(BaselineInfo.name);
  return {
    id: builder.id('id'),
    productId: builder.str('productId'),
    siteId: builder.str('siteId'),
    date: builder.date('date', DateParser_1.DateParser.ISO_PATTERN),
    amount: builder.num('amount')
  };
}();